import { ISbStoryData } from 'storyblok-js-client';

import { getSharedData } from '@monoimin/utils/api/getSharedData';

import { getStories } from '@monoimin/storyblok/getStories';
import { GetStoriesParams } from '@monoimin/storyblok/types';

/**
 * Фетчит одну историю по UUID с кэшированием
 * Работает с любым типом Storyblok компонента через generic
 * Принимает все параметры getStories для максимальной гибкости
 */
export const fetchStoryByUuid = async <T = any>(
  uuid: unknown,
  params?: Omit<GetStoriesParams, 'by_uuids_ordered' | 'by_uuids'>
): Promise<ISbStoryData<T> | null> => {
  if (!uuid || typeof uuid !== 'string') return null;

  const fullParams: GetStoriesParams = {
    ...params,
    by_uuids_ordered: uuid,
    per_page: 1,
  };

  return getSharedData(async () => {
    try {
      const { data } = await getStories<T>(fullParams);

      return data.stories[0] || null;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Failed to fetch story by UUID:', error);
      return null;
    }
  }, `${uuid}:${params?.language || 'default'} ${params?.excluding_fields}`);
};
